import { FormattedMessage } from 'gatsby-plugin-intl';
import * as React from 'react';
import { Col, Grid, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import SectionPath from '../../../styles/static/secondSectionPath.svg';
import { media } from '../../../styles/theme';
import { Flex } from '../../common/Flex';
import { Indent, IndentInsensible } from '../../common/Indent';
import { StyledText } from '../../common/StyledText';
import { TitleLine } from '../../common/TitleLine';
import { FutureBlock } from './FutureBlock';
import { PartnerInfoBlock } from './PartnerInfoBlock';

const devicesSrc = require('../../../styles/static/devices.png');
const devicesSrc2x = require('../../../styles/static/devices@2x.png');

export const PartnerInfo = () => {
  return (
    <>
      <Section>
        <SecondBackground>
          <SectionPath />
        </SecondBackground>
        <Grid>
          <div style={{ pointerEvents: 'all' }}>
            <Indent smTop={3.5} smBottom={5} mdBottom={7} width='100%'>
              <Row>
                <Col xs={12}>
                  <Flex align='center' direction='column' mdAlign='flex-start'>
                    <Indent bottom={1}>
                      <h2>
                        <StyledText
                          color='textInverted'
                          size='1.8'
                          smSize='2.25'
                          xsAlign='center'
                          smAlign='left'
                          type='inline-block'>
                          <FormattedMessage id='homepage.secondSection.title' />
                        </StyledText>
                      </h2>
                    </Indent>
                    <TitleLine width='220px' />
                  </Flex>
                </Col>
              </Row>
              <Indent xsTop={2} mdTop={-0.5} mdLeft={-1} lgLeft={-2}>
                <Row>
                  <Flex align='stretch'>
                    <Col xs={12} sm={6} md={3}>
                      <IndentInsensible mdTop={4} mdHeight='100%' width='100%'>
                        <PartnerInfoBlock
                          icon='addUser'
                          title={<FormattedMessage id='homepage.partnerFirstInfoBlock.title' />}
                          description={<FormattedMessage id='homepage.partnerFirstInfoBlock.description' />}
                          withChain
                        />
                      </IndentInsensible>
                    </Col>
                    <Col xs={12} sm={6} md={3}>
                      <IndentInsensible mdTop={2} mdHeight='100%' width='100%'>
                        <PartnerInfoBlock
                          icon='userGroup'
                          title={<FormattedMessage id='homepage.partnerSecondInfoBlock.title' />}
                          description={<FormattedMessage id='homepage.partnerSecondInfoBlock.description' />}
                          withChain
                          isEven
                        />
                      </IndentInsensible>
                    </Col>
                    <Col xs={12} sm={6} md={3}>
                      <IndentInsensible mdHeight='100%' width='100%'>
                        <PartnerInfoBlock
                          icon='dollarUp'
                          title={<FormattedMessage id='homepage.partnerThirdInfoBlock.title' />}
                          description={<FormattedMessage id='homepage.partnerThirdInfoBlock.description' />}
                          withChain
                        />
                      </IndentInsensible>
                    </Col>
                    <Col xs={12} sm={6} md={3}>
                      <IndentInsensible mdBottom={2} mdTop={0} mdHeight='100%' width='100%'>
                        <PartnerInfoBlock
                          icon='money'
                          title={<FormattedMessage id='homepage.partnerFourthInfoBlock.title' />}
                          description={<FormattedMessage id='homepage.partnerFourthInfoBlock.description' />}
                          isEven
                        />
                      </IndentInsensible>
                    </Col>
                  </Flex>
                </Row>
              </Indent>
            </Indent>
          </div>
        </Grid>
      </Section>
      <FeaturesSection>
        <Grid>
          <Row>
            <Col xs={12} md={4} lg={6}>
              <Flex justify='center' mdJustify='flex-end'>
                <Indent mdTop={9} lgTop={7}>
                  <IndentInsensible mdRight={2} lgRight={5}>
                    <Devices>
                      <img srcSet={`${devicesSrc}, ${devicesSrc2x} 2x`} alt='' width='585' />
                    </Devices>
                  </IndentInsensible>
                </Indent>
              </Flex>
            </Col>
            <Col xs={12} md={8} lg={6}>
              <Row>
                <Col xs={12}>
                  <Indent bottom={1.5} type='block'>
                    <Flex direction='column' align='center' mdAlign='flex-start'>
                      <Indent top={2.5} bottom={1.2}>
                        <h2>
                          <StyledText
                            color='textInverted'
                            type='block'
                            size='2'
                            smSize='2.625'
                            lineHeight='1.2'
                            xsAlign='center'
                            mdAlign='left'>
                            <FormattedMessage id='homepage.thirdSection.title' />
                          </StyledText>
                        </h2>
                      </Indent>
                      <TitleLine width='70%' />
                    </Flex>
                  </Indent>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Indent bottom={2.25} type='block'>
                    <StyledText color='textInverted' size='1.15'>
                      <FormattedMessage id='homepage.thirdSection.description' />
                    </StyledText>
                  </Indent>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <Indent bottom={1} type='block'>
                    <StyledText
                      color='textInverted'
                      type='block'
                      align='center'
                      mdAlign='left'
                      size='1.2'
                      mdSize='0.875'
                      weight='200'
                      letterSpacing='2px'>
                      <FormattedMessage id='homepage.thirdSection.featuresTitle' />
                    </StyledText>
                  </Indent>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6}>
                  <FutureBlock icon='building' title={<FormattedMessage id='homepage.futures.firstFuture' />} />
                </Col>
                <Col xs={12} sm={6}>
                  <FutureBlock icon='platforms' title={<FormattedMessage id='homepage.futures.secondFuture' />} />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={6}>
                  <FutureBlock icon='user' title={<FormattedMessage id='homepage.futures.thirdFuture' />} />
                </Col>
                <Col xs={12} sm={6}>
                  <FutureBlock icon='leaderboard' title={<FormattedMessage id='homepage.futures.fourthFuture' />} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </FeaturesSection>
    </>
  );
};

const Section = styled.div`
  padding: 30px 0 30px;
  background: transparent;
  position: relative;
  z-index: 2;
  background-color: ${p => p.theme.backgroundColor};
  pointer-events: none;

  @media (min-width: 26rem){
    margin-top: -130px;
  }

  ${media.sm`
    background-color: transparent;
    margin-top: -245px;
    margin-bottom: -50px;
    padding: 130px 0 160px;
  `}

  ${media.md`
    margin-top: -175px;
  `}

  ${media.lg`
    margin-top: -235px;
  `}
`;

const thirdSectionBackground = require('../../../styles/static/thirdScreen.png');

const FeaturesSection = styled.div`
  background-size: cover;
  position: relative;
  z-index: 1;
  padding-top: 30px;
  background: url(${thirdSectionBackground}) 0 0 no-repeat, linear-gradient(239deg, #20253b 50%, transparent 100%);
  background-size: cover;
  padding-bottom: 50px;

  ${media.sm`
    padding-top: 150px;
    margin-top: -280px;
    padding-bottom: 100px;
    `};
`;

const SecondBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -1;
  visibility: hidden;

  svg {
    width: 100%;
    height: 100%;
  }

  ${media.sm`
    visibility: visible;
  `}
`;

const Devices = styled.picture`
  img {
    max-width: 100%;

    ${media.md`max-width: initial`}
  }
`;
